const getScopedExistingArray = ({ items, ownerCompanyId = null, activeCompanyId = null } = {}) => {
  if (!Array.isArray(items)) {
    return [];
  }

  const normalizedOwnerCompanyId = String(ownerCompanyId || '').trim();
  const normalizedActiveCompanyId = String(activeCompanyId || '').trim();

  if (!normalizedOwnerCompanyId || !normalizedActiveCompanyId || normalizedOwnerCompanyId === normalizedActiveCompanyId) {
    return items;
  }

  return [];
};

export default getScopedExistingArray;
